import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import 'tinymce';
import 'tinymce/themes/silver';
import 'tinymce/plugins/paste/plugin'
import 'tinymce/plugins/link/plugin'
import 'tinymce/plugins/table/plugin'
import 'tinymce/plugins/autoresize/plugin'
import 'tinymce/plugins/preview/plugin'
import { Editor } from '@tinymce/tinymce-react';
import {Modal, ModalBody, ModalHeader, ModalFooter, Button} from 'reactstrap';
import {observable} from "mobx";
import {AudioRecorder} from "../../AudioRecorder";
import {config} from "config";
import {autobind} from "core-decorators";

interface TinyMCEProps {
    onChange?;
    toolbar?: string;
    height?: number;
    value?: string;
    editor?: (editor: Editor) => any;
}

@observer export class TinyMCE extends Component<TinyMCEProps, any> {

    editor: any;

    @observable file;
    @observable audioModal = false;

    handleEditorChange = (e) => {
        this.props.onChange(e.target.getContent());
    };

    @autobind submit() {
        const file = `[a:${this.file.split('audio_file_')[1]}]`;

        /*this.editor.editor
            .setContent(
                '<p>' +
                this.editor.editor
                    .getContent({ format: 'raw' })
                    .replace(/<[^>]*>/g, '') + ' ' + file +
                '</p>'
            );*/

        this.editor.editor.execCommand('mceInsertContent', false, file)

        this.audioModal = false;
    }

    render() {
        const { toolbar } = this.props;

        return <>
            <Editor
                ref={elm => {
                    this.editor = elm;
                    this.props.editor && this.props.editor(elm);
                }}
                initialValue={ this.props.value || '' }
                onExecCommand={result => {
                    if (result.command === 'record_audio') {
                        this.audioModal = true;
                    }
                }}
                onInit={e => {
                    const tags = e.target.dom.select('audio');

                    for (const node of tags) {
                        e.target.dom.replace(document.createTextNode("[a:" + node.src.replace(config.audioUploadPrefix, '') + "]"), node);
                    }
                }}
                onPostProcess={e => {
                    e.content = e.content.replace(/\[a:([^\]]+)\]/ig, '<audio controls src="' + config.audioUploadPrefix + '$1"></audio>');
                }}
                init={{
                    content_css : "/assets/content.css",
                    height: this.props.height || 200,
                    table_class_list: [
                        { title: 'None', value: '' },
                        { title: 'Preset 1', value: 'preset-1' },
                    ],
                    menubar: false,
                    branding: false,
                    plugins: [
                        'table paste link autoresize mnemo_keyword preview'
                    ],
                    toolbar:
                       this.props.toolbar !== undefined ? this.props.toolbar : 'bold'
                }}
                onChange={this.handleEditorChange}
            />

            { toolbar && toolbar.includes('audio') && (
                <Modal isOpen={this.audioModal}
                       className={'large-modal'}
                       toggle={() => this.audioModal = !this.audioModal}>
                    <ModalHeader toggle={() => this.audioModal = !this.audioModal}>Record Audio</ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <AudioRecorder onChange={e => {
                                this.file = e;
                            }} />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.submit}>Add Audio</Button>
                    </ModalFooter>
                </Modal>
            ) }
        </>
    }

}
